export default {
  setEngagementCategories(state, { categoryType, categories }) {
    state.engagementCategories[categoryType] = categories;
  },
  setEngagementCategoriesForSelect(state, { categoryType, categories }) {
    state.engagementCategoriesForSelect[categoryType] = categories;
  },
};
